import { TransferOrderStatus } from '../constants/transfer-order-status.js';
export const TRANSFER_ORDER_OPEN_STATUS_IDS = [
    TransferOrderStatus.ISSUED,
    TransferOrderStatus.PICK,
    TransferOrderStatus.SHIPPED,
    TransferOrderStatus.PARTIALLY_RECEIVED,
];
//# sourceMappingURL=transfer-order-open-status-ids.js.map